<sbnb-confetti #confetti></sbnb-confetti>

<div class="flex flex-col justify-between">
  <h3>You did it! Your site is ready 🎉</h3>

  <p class="font-bold text-night mb-8 mt-6">All you have to do is add the finishing touches and publish your site.</p>

  <ng-container *ngIf="payoutMethods">
    <div class="flex gap-2">
      <sbnb-button size="mini" type="secondary" (clicked)="dialogRef.close()">I'll do this later</sbnb-button>

      <sbnb-button *ngIf="!payoutMethods.length" size="mini" type="primary" (clicked)="addPayoutMethod()">
        Add payout method
      </sbnb-button>

      <sbnb-button *ngIf="payoutMethods.length" size="mini" type="primary" (clicked)="dialogRef.close('publish')">
        Publish your Site
      </sbnb-button>
    </div>
  </ng-container>

  <ng-container *ngIf="!payoutMethods">
    <mat-spinner [diameter]="24"></mat-spinner>
  </ng-container>
</div>
